export const analytics = {
  pageView() {
    if (typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'PageView')
  },

  search(searchTerm) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'Search', {
      search_string: searchTerm
    })
  },

  addToCart(product, price, quantity = 1) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'AddToCart', {
      content_ids: [product._id],
      content_name: product.title,
      content_type: 'product',
      value: price,
      currency: 'BDT',
      num_items: quantity,
    })
  },

  addToWishlist(product, price, quantity = 1) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'AddToWishlist', {
      content_ids: [product._id],
      content_name: product.title,
      content_type: 'product',
      value: price,
      currency: 'BDT',
      num_items: quantity,
    })
  },

  viewContent(product, price) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'ViewContent', {
      content_ids: [product._id],
      content_name: product.title,
      content_type: 'product',
      value: price,
      currency: 'BDT',
    })
  },

  initiateCheckout(cartItems, cartTotal) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'InitiateCheckout', {
      content_ids: cartItems.map(item => item._id),
      content_type: 'product',
      num_items: cartItems.length,
      value: Number(cartTotal),
      currency: 'BDT'
    })
  },

  purchase(orderedItems, subTotal, eventId) {
    if (typeof window === 'undefined' || !window.fbq) return

    window.fbq('track', 'Purchase',
      {
        content_ids: orderedItems.map(p => p._id),
        value:  Number(subTotal),
        currency: 'BDT',
      },
      {
        eventID: eventId
      })
  },
}